const STEPS = [
  {
    id: "reach-out",
    num: "01",
    title: "Reach Out",
    description: "Call or email to describe what's going on. No automated phone calls, you'll get a real response.",
  },
  {
    id: "get-a-quote",
    num: "02",
    title: "Get a Quote",
    description: "We diagnose the issue and give you a clear, honest estimate before any work is authorized.",
  },
  {
    id: "agree-on-location",
    num: "03",
    title: "Agree on a Location",
    description: "We come to you - your driveway, your workplace, or wherever makes sense. We'll sort out the details together.",
  },
  {
    id: "drive-away",
    num: "04",
    title: "Drive Away Fully Repaired",
    description: "Work completed, explained, and backed. You leave knowing what was done and why.",
  },
]

export default STEPS